import { apiService } from './apiService'
import { Subscription, SubscriptionFilters, PaginatedResponse, ExportRequest } from '@types'

export const subscriptionService = {
  // 获取订阅列表
  async getSubscriptions(filters: SubscriptionFilters): Promise<PaginatedResponse<Subscription>> {
    const params = new URLSearchParams()

    if (filters.status && filters.status !== 'all') {
      params.append('status', filters.status)
    }
    if (filters.gardenId && filters.gardenId !== 'all') {
      params.append('gardenId', filters.gardenId)
    }
    if (filters.userId && filters.userId !== 'all') {
      params.append('userId', filters.userId)
    }
    if (filters.startDate) {
      params.append('startDate', filters.startDate)
    }
    if (filters.endDate) {
      params.append('endDate', filters.endDate)
    }
    if (filters.search) {
      params.append('search', filters.search)
    }
    if (filters.page) {
      params.append('page', filters.page.toString())
    }
    if (filters.pageSize) {
      params.append('pageSize', filters.pageSize.toString())
    }

    return apiService.get<PaginatedResponse<Subscription>>(`/subscriptions?${params.toString()}`)
  },

  // 获取订阅详情
  async getSubscriptionDetail(id: string): Promise<Subscription> {
    return apiService.get<Subscription>(`/subscriptions/${id}`)
  },

  // 更新订阅状态
  async updateSubscriptionStatus(id: string, status: 'active' | 'expired' | 'cancelled'): Promise<void> {
    return apiService.put(`/subscriptions/${id}/status`, { status })
  },

  // 更新订阅信息
  async updateSubscription(id: string, data: Partial<Subscription>): Promise<Subscription> {
    return apiService.put<Subscription>(`/subscriptions/${id}`, data)
  },

  // 获取订阅统计
  async getSubscriptionStatistics(filters: SubscriptionFilters): Promise<any> {
    const params = new URLSearchParams()
    
    if (filters.status && filters.status !== 'all') {
      params.append('status', filters.status)
    }
    if (filters.gardenId && filters.gardenId !== 'all') {
      params.append('gardenId', filters.gardenId)
    }
    if (filters.startDate) {
      params.append('startDate', filters.startDate)
    }
    if (filters.endDate) {
      params.append('endDate', filters.endDate)
    }
    if (filters.search) {
      params.append('search', filters.search)
    }

    return apiService.get(`/subscriptions/statistics?${params.toString()}`)
  },

  // 导出订阅数据（CSV）
  async exportSubscriptions(filters: SubscriptionFilters, format: 'excel' | 'csv' | 'pdf'): Promise<void> {
    const exportRequest: ExportRequest = {
      filters,
      format,
      fields: [
        'id',
        'userName',
        'gardenName',
        'planType',
        'monthlyPrice',
        'subscriptionDate',
        'expiryDate',
        'status',
        'totalAmount',
      ],
    }
    const name = `subscriptions_${new Date().toISOString().split('T')[0]}.csv`
    return apiService.postDownload('/subscriptions/export', exportRequest, name)
  },

  // 批量更新订阅状态
  async batchUpdateStatus(ids: string[], status: 'active' | 'expired' | 'cancelled'): Promise<void> {
    return apiService.put('/subscriptions/batch/status', { ids, status })
  },

  // 获取订阅趋势数据
  async getSubscriptionTrend(timeRange: string = '30d'): Promise<any> {
    return apiService.get(`/subscriptions/trend?range=${timeRange}`)
  },

  // 获取订阅状态分布
  async getStatusDistribution(): Promise<any> {
    return apiService.get('/subscriptions/status-distribution')
  },

  // 获取热门菜园
  async getTopGardens(limit: number = 10): Promise<any> {
    return apiService.get(`/subscriptions/top-gardens?limit=${limit}`)
  },

  // 获取订阅收入统计
  async getRevenueStatistics(timeRange: string = '30d'): Promise<any> {
    return apiService.get(`/subscriptions/revenue?range=${timeRange}`)
  },
}








